const BASE_CURRENCY = "USD";

export const normalizeCurrencyCode = (value) => {
  const code = String(value || "").trim().toUpperCase();
  return /^[A-Z]{3}$/.test(code) ? code : "";
};

export const normalizeCountryCode = (value) => {
  const code = String(value || "").trim().toUpperCase();
  return /^[A-Z]{2}$/.test(code) ? code : "";
};

export const getLocalCurrencyForCountry = (country) =>
  normalizeCurrencyCode(country?.currencyCode || country?.currency) || BASE_CURRENCY;

export const getAllowedCurrenciesForCountry = (country) => {
  const configured = Array.isArray(country?.allowedCurrencyCodes)
    ? country.allowedCurrencyCodes
    : Array.isArray(country?.allowedCurrencies)
      ? country.allowedCurrencies
      : null;

  if (configured?.length) {
    const allowed = Array.from(new Set(configured.map(normalizeCurrencyCode).filter(Boolean)));
    return allowed.length ? allowed : [BASE_CURRENCY];
  }

  const countryCode = normalizeCountryCode(country?.countryCode || country?.code);
  if (countryCode === "US") return [BASE_CURRENCY];
  if (countryCode === "BD") return [BASE_CURRENCY, "BDT"];

  const localCurrency = getLocalCurrencyForCountry(country);
  return Array.from(new Set([localCurrency, BASE_CURRENCY]));
};

export const getDefaultCurrencyForCountry = (country) => {
  const configuredDefault = normalizeCurrencyCode(
    country?.defaultCurrencyCode || country?.defaultCurrency
  );
  if (configuredDefault) return configuredDefault;

  const countryCode = normalizeCountryCode(country?.countryCode || country?.code);
  if (countryCode === "US" || countryCode === "BD") return BASE_CURRENCY;
  return getLocalCurrencyForCountry(country);
};

export const resolveCurrencyForCountry = (country, candidateCurrency, { allowCandidate = true } = {}) => {
  const fallback = getDefaultCurrencyForCountry(country);
  const candidate = normalizeCurrencyCode(candidateCurrency);
  if (!candidate || !allowCandidate) return fallback;

  const allowed = new Set(getAllowedCurrenciesForCountry(country));
  return allowed.has(candidate) ? candidate : fallback;
};
